import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatLegacySlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatLegacyTabsModule } from '@angular/material/legacy-tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { MenuComponent } from '@app/core/components/header/menu/menu.component';
import { UuidService } from '@app/core/services/uuid.service';
import { RouteCheckPipe } from '@app/features/create-cv/pipes/route-check.pipe';
import { UploadStatusModalComponent } from '@app/features/upload-cv/modals/upload-status-modal/upload-status-modal.component';
import { UploadCvComponent } from '@app/features/upload-cv/upload-cv.component';
import {
  ButtonModule,
  LanguagePickerModule,
  ProfileMenuModule,
  SelectModule,
} from '@hohr/components';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { I18NextModule } from 'angular-i18next';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { MonthYearInputComponent } from './components/month-year-input/month-year-input.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { DestroyableDirective } from './directives/destroyable';
import { DragAndDropFileDirective } from './directives/drag-and-drop-file.directive';
import { CustomAuthenticationGuard } from './guards/custom-authentication.guard';
import { UnsavedChangesGuard } from './guards/unsaved-changes.guard';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';

@NgModule({
  declarations: [
    MonthYearInputComponent,
    SpinnerComponent,
    RouteCheckPipe,
    MenuComponent,
    UploadCvComponent,
    UploadStatusModalComponent,
    DragAndDropFileDirective,
    ConfirmModalComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    RouterModule,
    NgxTrimDirectiveModule,
    MatInputModule,
    MatLegacyButtonModule,
    MatListModule,
    MatSelectModule,
    MatToolbarModule,
    MatIconModule,
    MatDividerModule,
    MatCardModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatStepperModule,
    MatChipsModule,
    MatSliderModule,
    MatLegacySlideToggleModule,
    MatLegacyTabsModule,
    MatDialogModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatMenuModule,
    ClipboardModule,
    I18NextModule,
    ButtonModule,
    SelectModule,
    I18NextModule,
    ProfileMenuModule,
  ],
  exports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    NgxTrimDirectiveModule,
    MatFormFieldModule,
    MatInputModule,
    MatLegacyButtonModule,
    MatListModule,
    MatSelectModule,
    MatToolbarModule,
    MatIconModule,
    MatDividerModule,
    MatCardModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatStepperModule,
    MatChipsModule,
    MatSliderModule,
    MatLegacySlideToggleModule,
    MatLegacyTabsModule,
    MonthYearInputComponent,
    MatDialogModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatMenuModule,
    ClipboardModule,
    I18NextModule,
    SpinnerComponent,
    ButtonModule,
    RouteCheckPipe,
    SelectModule,
    MenuComponent,
    UploadCvComponent,
    UploadStatusModalComponent,
    IonicModule,
    ProfileMenuModule,
    LanguagePickerModule,
  ],
  providers: [
    DestroyableDirective,
    MatDatepickerModule,
    MatNativeDateModule,
    CustomAuthenticationGuard,
    UnsavedChangesGuard,
    UuidService,
    provideMomentDateAdapter(),
  ],
})
export class SharedModule {}
